import { ToggleOffFlex as ToggleOffFlexIcon } from "@clockwise/web-commons/src/components/svgs/ToggleOffFlex";
import { ToggleOnFlex as ToggleOnFlexIcon } from "@clockwise/web-commons/src/components/svgs/ToggleOnFlex";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { AssistantOutlined } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import { toast } from "react-hot-toast";
import { ListItemButton } from "../calendar-popover/atoms/ListItemButton";
import { useToggleFlexibility } from "../hooks/useToggleFlexibility";

const ToggleOnFlex = () => {
  return <ToggleOnFlexIcon />;
};

const ToggleOffFlex = () => {
  return <ToggleOffFlexIcon />;
};

export const FlexQuickAction = ({
  externalEventId,
  truncatedTitle,
  calendarId,
  onClose,
  loading,
  refetch,
  isFlexible,
  canMarkFlexible,
}: {
  externalEventId: string;
  truncatedTitle: string;
  calendarId: string;
  onClose: () => void;
  loading: boolean;
  refetch: () => void;
  isFlexible: boolean;
  canMarkFlexible: boolean;
}) => {
  const track = useTracking();
  const { update: toggleFlexibility } = useToggleFlexibility(externalEventId, calendarId);

  const isFlexibilitySelectionDisabled = !canMarkFlexible;
  const meetingIsNotFlex = !isFlexible;

  const onToggleFlexibility = () => {
    if (meetingIsNotFlex) {
      track(TrackingEvents.EVENT_POPOVER.FLEXIBILITY_TOGGLED, {
        flex: true,
      });
      void toggleFlexibility({
        variables: { toggleToOn: true },
        onCompleted: () => {
          refetch();
          toast.success(`Marked ${truncatedTitle} as flexible`);
        },
        onError: () => {
          toast.error(`Failed to update ${truncatedTitle}`);
        },
      });
    } else {
      track(TrackingEvents.EVENT_POPOVER.FLEXIBILITY_TOGGLED, {
        flex: false,
      });
      void toggleFlexibility({
        variables: { toggleToOn: false },
        onCompleted: () => {
          refetch();
          toast.success(`Marked ${truncatedTitle} as not flexible`);
        },
        onError: () => {
          toast.error(`Failed to update ${truncatedTitle}`);
        },
      });
    }
  };
  if (loading)
    return (
      <div className="cw-py-1 cw-my-1 cw-px-1 cw-flex cw-items-center cw-gap-2">
        <Skeleton variant="circle" height={16} width={16} className="cw-ml-[2px]" />
        <Skeleton variant="rect" height={24} className="cw-flex-grow cw-rounded-md" />
        <ToggleOffFlexIcon opacity={0.25} />
      </div>
    );

  if (isFlexibilitySelectionDisabled) return null;
  return (
    <ListItemButton
      startIcon={AssistantOutlined}
      endIcon={meetingIsNotFlex ? ToggleOffFlex : ToggleOnFlex}
      onClick={() => {
        onToggleFlexibility();
        onClose();
      }}
    >
      {meetingIsNotFlex ? "Mark as flexible" : " Flexible meeting"}
    </ListItemButton>
  );
};
